// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"260b427a","453":"e0996caa","821":"9d05dac5"}[chunkId] + ".chunk.js";
};